window.addEventListener("DOMContentLoaded", function() {

    $('.SizeSelectorButton').click(function() {
        $(this).toggleClass('is-open');
        $('.SizeSelector__dropdown').toggle();
    });

    $('body').on("click", function(event) {
        if (!$(event.target).closest(".customSize").length) {
            $(this).removeClass('is-open');
            $('.SizeSelector__dropdown').hide();
        }
    });

    $('.SizeSelectorList__item').click(function() {
 
        let size = $(this).data('size');
        let inventory = $(this).find('.inventory-status').text();
        let ships_in = $(this).find('.SizeSelectorItem__equivalents').text().trim();
        let new_divs = `<span class="Text Text--body1 " style="color:rgb(59,60,54)">${size}</span> <span class="Text Text--body1 " style="color: rgb(59,60,54);">${inventory}</span>`;
        $(this).removeClass('is-open');
        $('.SizeSelector__dropdown').hide();
        $('.SizeSelectorButton .Stack.Stack--horizontal-3').html(new_divs);
        $(`.product__color-chips > button[aria-label="${size}"]`).click();
        $('.dynamic-ship-status').text(ships_in);

    })


    $('.Expandable').click(function() {
        $(this).toggleClass('Expandable--expanded')
    });


})